<template>
    <transition
        enter-active-class="transition-opacity duration-300 ease-linear"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition-opacity duration-300 ease-linear"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div v-show="show" class="relative z-20 flex justify-center">
            <div class="fixed inset-0 z-40 backdrop-blur" @click="closeModal">
                <div class="absolute inset-0 bg-gray-800 opacity-75"></div>
            </div>

            <div
                class="fixed top-0 left-auto lg:left-1/2 lg:-ml-[18rem] z-50 w-full max-w-xl mt-8 lg:top-auto lg:mt-0 px-5 lg:px-0"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-headline"
            >
                <div class="relative flex flex-col w-full bg-white">
                    <div class="bg-brand-blue flex justify-between items-center px-5 lg:px-8 py-5 lg:py-6">
                        <span class="text-xl lg:text-3xl font-semibold text-white">
                            Please Select a Location
                        </span>

                        <button
                            type="button"
                            @click="closeModal"
                        >
                             <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M24 8L8 24" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8 8L24 24" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>

                    <div class="px-5 lg:px-8 py-5">
                        <county-selector
                            :counties="regions"
                            @countySelected="setRegion($event)"
                        ></county-selector>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex';

import CountySelector from "./CountySelector.vue";

export default {
    components: {
        CountySelector
    },

    data: () => ({
        show: false,
    }),

    created() {
        this.$event.$on('regions-modal:show', this.showModal);
        this.$event.$on('regions-modal:close', this.closeModal);
    },

    computed: {
        ...mapGetters('lead', [
            'regions'
        ])
    },

    methods: {
        /**
         * Set the modal to show.
         */
        showModal() {
            this.show = true;
        },

        /**
         * Set the modal to hide.
         */
        closeModal() {
            this.show = false;
        },

        /**
         * Update the form with the new region information.
         *
         * @param {array} region
         */
        setRegion(region) {
            this.$store.commit(
                'lead/updateForm',
                { region_id: region.criteria_id }
            );

            this.$store.commit('lead/selectedRegion', region);

            this.closeModal();
        },
    }
};
</script>
